import { render, staticRenderFns } from "./FollowerFormEventSelection.vue?vue&type=template&id=45b739ea&scoped=true&"
import script from "./FollowerFormEventSelection.vue?vue&type=script&lang=js&"
export * from "./FollowerFormEventSelection.vue?vue&type=script&lang=js&"
import style0 from "./FollowerFormEventSelection.vue?vue&type=style&index=0&id=45b739ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b739ea",
  null
  
)

export default component.exports